import { PlusIcon, TrashIcon } from "@phosphor-icons/react";
import { INPUT_CLS } from "../crm/Form";

export default function PartsTable({ value, onChange, disabled }) {
  const rows = value || [];

  const update = (idx, patch) => {
    const next = rows.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };

  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const add = () =>
    onChange([...rows, { label: "", qty: 1, notes: "" }]);

  return (
    <div data-testid="parts-table" className="space-y-2">
      <div className="grid grid-cols-12 gap-2 text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
        <div className="col-span-5">Part / SKU</div>
        <div className="col-span-2">Qty</div>
        <div className="col-span-4">Notes</div>
        <div className="col-span-1" />
      </div>
      {rows.length === 0 && (
        <div className="text-xs text-slate-500">No parts identified yet.</div>
      )}
      {rows.map((row, i) => (
        <div
          key={i}
          className="grid grid-cols-12 gap-2 items-start"
          data-testid={`parts-row-${i}`}
        >
          <input
            type="text"
            value={row.label || ""}
            disabled={disabled}
            onChange={(e) => update(i, { label: e.target.value })}
            placeholder="e.g. Enphase IQ8 cable"
            className={`${INPUT_CLS} col-span-5`}
            data-testid={`parts-label-${i}`}
          />
          <input
            type="number"
            min="1"
            value={row.qty ?? 1}
            disabled={disabled}
            onChange={(e) =>
              update(i, { qty: Math.max(1, Number(e.target.value) || 1) })
            }
            className={`${INPUT_CLS} col-span-2`}
            data-testid={`parts-qty-${i}`}
          />
          <input
            type="text"
            value={row.notes || ""}
            disabled={disabled}
            onChange={(e) => update(i, { notes: e.target.value })}
            placeholder="optional notes"
            className={`${INPUT_CLS} col-span-4`}
            data-testid={`parts-notes-${i}`}
          />
          <button
            type="button"
            disabled={disabled}
            onClick={() => remove(i)}
            data-testid={`parts-remove-${i}`}
            aria-label="Remove part"
            className="col-span-1 inline-flex h-9 items-center justify-center rounded-md border border-slate-200 text-slate-500 hover:text-red-600 hover:border-red-200 disabled:opacity-40"
          >
            <TrashIcon size={14} />
          </button>
        </div>
      ))}
      <button
        type="button"
        disabled={disabled}
        onClick={add}
        data-testid="parts-add"
        className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-slate-700 hover:text-amber-700 disabled:opacity-40"
      >
        <PlusIcon size={12} weight="bold" /> Add part
      </button>
    </div>
  );
}
